import React, { useEffect } from 'react'
import styled from 'styled-components'
import {
  LocalLabelsProvider,
  useCustomUI,
  useUIState,
} from '@sentecacommerce-theme/lib'
import {
  BottomStrip,
  Contacts,
  Menu,
  MenuList,
  NewsletterForm,
} from './Components/'
import { useInView } from 'react-intersection-observer'
import { FooterProps, FooterLabels } from './footer.props'

export const Footer = (props: FooterProps) => {
  const { menus, contactMenu, bottomStrip, labels } = props
  const { ref, inView } = useInView({
    threshold: 0,
    initialInView: false,
  })
  const [uiState, setUIState] = useCustomUI()

  useEffect(() => {
    if (inView) {
      setUIState({
        ...uiState,
        isFooterInView: true,
      })
    } else {
      setUIState({
        ...useUIState,
        isFooterInView: false,
      })
    }
  }, [inView])

  return (
    <LocalLabelsProvider<FooterLabels> labels={labels}>
      <div ref={ref} id="footer" className="mt-5 pt-5">
        <FooterBackground>
          <FooterContainer>
            <NewsletterFormContainer>
              <NewsletterForm />
            </NewsletterFormContainer>
            <FlexBox>
              <MainMenuContainer>
                <MenuList
                  menus={menus}
                  renderMenu={(menu) => <Menu {...menu} />}
                />
              </MainMenuContainer>
              <NewsletterFormContainer mobile>
                <Padding>
                  <NewsletterForm mobile />
                </Padding>
              </NewsletterFormContainer>
              <ContactsContainer>
                <Padding noPaddingOnDesktop>
                  {contactMenu && <Contacts {...contactMenu} />}
                </Padding>
              </ContactsContainer>
            </FlexBox>
          </FooterContainer>
          <BottomStripContainer>
            <BottomStrip items={bottomStrip} />
          </BottomStripContainer>
        </FooterBackground>
      </div>
    </LocalLabelsProvider>
  )
}

const FooterBackground = styled.footer.attrs({
  className: 'pt-lg-3',
})`
  /* background: ${({ theme }) => theme.palette.secondary}; */
  background: rgba(233, 245, 232, 0.5);
  color: ${({ theme }) => theme.palette.greyTitle};
  max-width: 100vw;
  overflow-x: hidden;
`
type NewsletterFormContainerProps = { mobile?: boolean }

const NewsletterFormContainer = styled.div.attrs(
  (props: NewsletterFormContainerProps) => {
    return {
      className: `col-12 ${props.mobile ? 'd-lg-none' : 'd-none d-lg-block'}`,
    }
  }
)<NewsletterFormContainerProps>`
  @media (min-width: ${({ theme }) => theme.breakpoints.lg.min}) {
    padding-bottom: 3rem;

    & > div {
      padding: 0 !important;
    }
  }
`

const FooterContainer = styled.div.attrs({
  className: 'container pt-5 pb-lg-4 ',
})``

const FlexBox = styled.div.attrs({
  className: 'row',
})``

const MainMenuContainer = styled.div.attrs({
  className: 'col-12 col-lg-9',
})``

const ContactsContainer = styled.div.attrs({
  className: 'col-12 col-lg-3',
})``

const Padding = styled.div.attrs((props: any) => ({
  className: `px-4${props.noPaddingOnDesktop ? ' p-lg-0' : ''}`,
}))<{ noBorder?: boolean; noPaddingOnDesktop?: boolean }>`
  padding-top: 2rem;
  padding-bottom: 2rem;
  border-bottom: ${(props) => (props.noBorder ? 0 : '0.1rem solid #e5e5e5')};

  @media (min-width: ${({ theme }) => theme.breakpoints.lg.min}) {
    border: 0;
    padding-top: 0;
    padding-bottom: 2.4rem;
  }
`

const BottomStripContainer = styled.section.attrs({})`
  padding: 2rem 0;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg.min}) {
    border-top: 0.1rem solid #e5e5e5;
    margin-top: 2rem;
    padding-top: 3rem;
  }
`
